import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3caea1cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-wrap" }
const _hoisted_2 = { class: "calls-wrap" }
const _hoisted_3 = { class: "status-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Typography = _resolveComponent("Typography")!

  return (_ctx.callData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["call-info", {'expand-call-info-restrictions': _ctx.settings.maximize}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Icon, {
            color: "--sui-gray-400",
            width: "32px",
            name: "ic24-user"
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Typography, {
            class: "number text",
            fontColor: _ctx.userColor ? '--sui-white' : '--sui-gray-900'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.callData?.number), 1)
            ]),
            _: 1
          }, 8, ["fontColor"]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.callData?.status === 'CONNECTED' && !_ctx.callData.active && !_ctx.incomingCall)
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 0,
                  class: "status text",
                  fontColor: "--sui-purple-500"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`${_ctx.t('statuses.pause')}  ·  `), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.callData?.status !== 'CONNECTED' && _ctx.callData?.status !== 'PROGRESSING' && !_ctx.incomingCall)
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 1,
                  class: "status text error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.errorText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentCallDuration && !_ctx.incomingCall && _ctx.callData?.status === 'CONNECTED')
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 2,
                  class: "call-time text",
                  fontColor: "--sui-purple-500"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.callData.active ? _ctx.timeFormat(_ctx.currentCallDuration.callDuration) : _ctx.timeFormat(_ctx.currentCallDuration.pauseDuration)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.incomingCall)
              ? (_openBlock(), _createBlock(_component_Typography, {
                  key: 3,
                  class: "call-time text animation",
                  fontColor: "--sui-gray-500"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('incomingCall')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}